import DownloadIcon from '@mui/icons-material/Download';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { styled } from '@mui/material/styles';
import { CircularProgress } from 'shared/mui/CircularProgress/CircularProgress';
import { IconButton } from 'shared/mui/IconButtons';

export const SuccessIconButtonStyled = styled(IconButton)(({ theme }) => ({
  height: '40px',
  width: '40px',
  backgroundColor: theme.palette.primary.main,
  '&:hover, &.Mui-disabled': {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const FailureIconButtonStyled = styled(IconButton)(({ theme }) => ({
  height: '40px',
  width: '40px',
  backgroundColor: theme.palette.divider,
  '&:hover': {
    backgroundColor: theme.palette.divider,
  },
}));

export const DownloadIconStyled = styled(DownloadIcon)(({ theme }) => ({
  color: theme.palette.background.default,
}));

export const CircularProgressStyled = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.background.default,
}));

export const RadioButtonUncheckedIconStyled = styled(RadioButtonUncheckedIcon)(({ theme }) => ({
  color: theme.palette.primary.light,
}));
